import api from '@/services/api';
import { handleException } from '@/utils/exception';
import { toast } from 'react-toastify';

import { type Plant, type PlantBasicDTO, type PlantDTO, type PlantStatusDTO } from '../types';

const BASE_URL = 'plants';

export const getPlants = async () => {
  return await api.get<PlantDTO[]>(BASE_URL);
};

export const getPlantsBasic = async () => {
  return await api.get<PlantBasicDTO[]>(`${BASE_URL}/basic`);
};

export const getPlantsWithProducts = async () => {
  return await api.get<Plant[]>(`${BASE_URL}/with-products`);
};

export const getPlant = async (id: number) => {
  return await api.get<Plant>(`${BASE_URL}/${id}`);
};

export const updatePlant = async (data: PlantDTO) => {
  try {
    await api.put(BASE_URL, data);
    toast.success('Plant updated successfully');
    return data;
  } catch (e) {
    toast.error(handleException(e, 'Failed to update plant'));
    throw e;
  }
};

export const createPlant = async (data: PlantDTO) => {
  try {
    await api.post(BASE_URL, data);
    toast.success('Plant created successfully');
    return data;
  } catch (e) {
    toast.error(handleException(e, 'Failed to create plant'));
    throw e;
  }
};

export const deletePlant = async (id: number) => {
  try {
    await api.delete(`${BASE_URL}/${id}`);
    toast.success('Plant deleted successfully');
  } catch (e) {
    toast.error(handleException(e, 'Failed to delete plant'));
    throw e;
  }
};

export const getPlantStatuses = async () => {
  return await api.get<PlantStatusDTO[]>(`${BASE_URL}/statuses`);
};
